module.exports = __webpack_public_path__ + "img/sw-bc02.2b56e689.png";